export default __webpack_public_path__ + "static/media/2.25ae7257.png";